import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Redirect non-canonical hostnames to app.flowstock.so
if (
  window.location.hostname !== "app.flowstock.so" &&
  window.location.hostname !== "localhost" &&
  !window.location.hostname.startsWith("127.") &&
  !window.location.hostname.startsWith("192.168.")
) {
  window.location.replace(
    `https://app.flowstock.so${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
